import RTMStreamChannel from "./rtmStreamChannel";
import QRTMPresence from "./qrtmPrensence";
import QRTMStorage from "./qrtmStorage";
import {
  RTMConfig,
  LoginResponse,
  LogoutResponse,
  ErrorInfo,
  SubscribeResponse,
  UnsubscribeResponse,
  PublishResponse,
} from "./rtmTypes";
import { EventEmitter } from "events";
import protooClient from "./protoo-client";
import deviceInfo from "./utils/deviceInfo";
import { Logger } from "./protoo-client/Logger";
import { EnhancedEventEmitter } from './protoo-client/EnhancedEventEmitter';

const logger = new Logger("RTM");
export class RTM extends EnhancedEventEmitter {
  private _appId: string;
  private _userId: string;
  private _rtmConfig: any;
  private _protooUrl: string;
  private _protoo: any;
  private _closed: boolean = true;
  private _eventEmitter: EventEmitter;
  private _events: Map<string, Array<Function>> | null = null;
  public presence: QRTMPresence;
  public storage: QRTMStorage;
  //构造
  constructor(appId: string, userId: string, rtmConfig?: RTMConfig) {
    super();
    // constructor logic goes here
    this._appId = appId;
    this._userId = userId;
    this._rtmConfig = rtmConfig;
    this._eventEmitter = new EventEmitter();
    this._events = new Map<string, Array<Function>>();
  }
  //析构函数
  public destructor() {
    //析构函数逻辑
    this._events.clear();
    this._eventEmitter.removeAllListeners();
    this._events = null;
    this._protooUrl = "";
  }

  //添加事件监听
  addEventListener(event: string, handler: (event: any) => void) {
    if (!this._events.has(event)) {
      this._events.set(event, []);
    }
    this._events.get(event)?.push(handler);
    //添加事件监听
    this._eventEmitter.on(event, handler);
  }

  //移除事件监听
  removeEventListener(event: string, handler: (event: any) => void) {
    if(!this._events || this._events.size == 0 || this._events == undefined) return;
    this._events.delete(event);
    //移除事件监听
    this._eventEmitter.removeAllListeners("event");
    //调用handler
    handler(event);
  }

  // 触发事件
  private triggerEvent(eventType: string, event: any) {
    this._eventEmitter.emit(eventType, event);
  }

  //创建并初始化 RTM 实例之后，你需要执行 login 操作以登录 RTM 服务。登录成功将使客户端与 RTM 服务器建立起长链接，之后客户端才能正常访问RTM资源
  //如果方法调用成功，则返回一个LoginResponse类型数据
  //如果方法调用失败，则返回一个 ErrorInfo 类型数据
  //只有在Login时才会触发notification
  async login(): Promise<LoginResponse> {
    const serverUrl = this._rtmConfig?.serverUrl ?? "ws://192.168.31.251:8002/";
    this._protooUrl = `${serverUrl}?roomId=${""}&peerId=${this._userId}`;
    // logger.debug(`enterRoom url=${this._protooUrl}`);
    // if(this._protoo){
    //     this._protoo.close();
    // }

    const protooTransport = new protooClient.WebSocketTransport(
      this._protooUrl,
      {
        clientConfig: { keepalive: true, keepaliveInterval: 30 * 1000 },
        maxRetryTime: 10 * 1000,
      }
    );

    this._protoo = new protooClient.Peer(protooTransport);
    this._protoo.on("disconnected", () => {
      //连接断开
      this._closed = true;
      this.close();
    });

    this._protoo.on("close", () => {
      logger.debug(`protoo on close!`);
      //if (this._closed) return;
      //this.close();
    });

    this._protoo.on("closedByServer", () => {
      logger.debug(`protoo closedByServer!`);
      //if (this._closed) return;
      this.safeEmit("closedByServer");
      //this.close();
    });

    this._protoo.on("connectionTimeOut", () => {
      // const { channelId, peerId } = notification.data;
      // console.log("_protoo通知连接断开!!!!!!")
     
      logger.debug(`protoo connectionTimeOut!`);
    });

    // eslint-disable-next-line no-unused-vars
    this._protoo.on("notification", (notification: any) => {
      logger.debug(
        `proto "notification" event [method:${notification.method}, data:${notification.data}]`
      );

      switch (notification.method) {
        case "producerCreated": {
          break;
        }
        case "memberJoin": {
          const { channelId, peerId } = notification.data;
          console.log("memberJoin::::", channelId, peerId)
          //订阅该频道且开启 Presence 事件监听的用户会收到 REMOTE_JOIN 类型的 presence 事件
          this.triggerEvent("presence", {
            action: "REMOTE_JOIN",
            channelType: "MESSAGE",
            channelName: channelId,
            publisher: peerId,
          });
          break;
        }
        case "memberLeave": {
          
          const { channelId, peerId } = notification.data;
          console.log("memberLeave::::", channelId, peerId)
          //其他订阅该频道并开启事件监听的用户会收到 REMOTE_LEAVE 类型的 presence 事件通知
          this.triggerEvent("presence", {
            action: "REMOTE_JOIN",
            channelType: "MESSAGE",
            channelName: channelId,
            publisher: peerId,
          });
          break;
        }
        case "channelMsgText": {
          const { channelId, peerId, msg } = notification.data;
          console.log("channelMsgText msg::::",  JSON.stringify(msg) )
          this.triggerEvent("message", {
            channelType: "MESSAGE",
            channelName: channelId,
            messageType: "string",
            publisher: peerId,
            message: msg,
          });
          break;
        }
        case "peerMsgText": {
          const { peerId, msg } = notification.data;
          this.triggerEvent("message", {
            channelType: "MESSAGE",
            messageType: "string",
            publisher: peerId,
            message: msg,
          });
          break;
        }
      }
    });

    try {
      await new Promise<void>((resolve, reject) => {
        this._protoo.on("open", async () => {
          // logger.debug(`protoo Peer "open" event`);
          this._closed = false;
          try {
            await this._protoo.request("login", {
              displayName: "123",
              device: { flag: "web", name: "web", version: "1.0" }, //deviceInfo()
              accessToken: this._rtmConfig?.token ?? "",
              appId: this._appId,
            });
            resolve();
          } catch (error) {
            reject({
              error: true,
              operation: "login",
              errorCode: 0,
              reason: "failed",
            });
          }
        });

        this._protoo.on("failed", () => {
          reject({
            error: true,
            operation: "login",
            errorCode: 0,
            reason: "failed",
          });
        });

        this._protoo.on("error", () => {
          reject({
            error: true,
            operation: "login",
            errorCode: 0,
            reason: "error",
          });
        });
      });
      logger.debug(`login success!`);
      return { timeToken: Date.now() };
    } catch (error) {
      logger.debug(`login failed:${error}`);
      throw error;
    }
  }

  async close() {
    if (this._closed) return;

    this._closed = true;
    //this.cleanStatus();
    // Close protoo Peer 这里加await不对
    this._protoo.close();
  }

  //可以通过以下接口退出登录状态，退出登录后，客户端与 RTM 服务器的长链接将会断开，之后客户端将无法正常访问 RTM 资源
  //如果方法调用成功，则返回一个LogoutResponse类型数据
  //如果方法调用失败，则返回一个 ErrorInfo 类型数据
  async logout(): Promise<LogoutResponse> {
    if (this._closed) {
      throw {
        error: true,
        operation: "logout",
        errorCode: 0,
        reason: "logout before login",
      };
    }
    this._closed = true;
    try {
      await this._protoo.request("logout", {
        peerId: this._userId,
      });
      //this.cleanStatus();
      this._protoo.close();
      return { timeToken: Date.now() };
    } catch (error) {
      logger.debug(`subscribe failed:${error}`);
      throw {
        error: true,
        operation: "logout",
        errorCode: 0,
        reason: "subscribe failed",
      };
    }
  }

  //通过调用 subscribe 方法，客户端可以订阅 Message Channel 并开始接收频道中的消息和事件通知。成功调用该方法后，
  //订阅该频道且开启 Presence 事件监听的用户会收到 REMOTE_JOIN 类型的 presence 事件
  async subscribe(
    channelName: string,
    options?: object
  ): Promise<SubscribeResponse> {
    try {
      await this._protoo.request("joinChannel", {
        channelId: channelName,
        //TODO: options
      });
      return { timeToken: Date.now(), channelName: channelName };
    } catch (error) {
      logger.debug(`subscribe failed:${error}`);
      throw {
        error: true,
        operation: "logout",
        errorCode: 0,
        reason: "subscribe failed",
      };
    }
  }

  //如果你不再需要关注某个频道，可调用 unsubscribe 方法取消订阅该频道。成功取消订阅该频道后，
  //其他订阅该频道并开启事件监听的用户会收到 REMOTE_LEAVE 类型的 presence 事件通知
  async unsubscribe(channelName: string): Promise<UnsubscribeResponse> {
    try {
      await this._protoo.request("leaveChannel", {
        channelId: channelName,
        //TODO: options
      });
      return { timeToken: Date.now(), channelName: channelName };
    } catch (error) {
      logger.debug(`subscribe failed:${error}`);
      throw {
        error: true,
        operation: "logout",
        errorCode: 0,
        reason: "unsubscribe failed",
      };
    }
  }

  //在使用 Stream Channel 之前，你需要先调用 createStreamChannel 方法创建 RTMStreamChannel 实例。
  //成功创建实例后，你可以调用其相关方法，例如：加入频道、离开频道、发送 Topic 消息、订阅 Topic 消息等
  async createStreamChannel(channelName: string): Promise<RTMStreamChannel> {
    try {
      const streamChannel: RTMStreamChannel = new RTMStreamChannel(channelName);
      return streamChannel;
    } catch (error: any) {
      throw error;
    }
  }

  //单独发消息给某人
  /*
  inviteMeeting:::{
    "action":"call","room":"9748188819","data":{"virtualNum":"8881","video":{"code":"H264","resolution":"1024X768"},"audio":{"sampleRate":"44100","channels":2}}}
  */
  async publishToPeer(
    peerId: string,
    message: string,
    options?: { customType?: string }
  ): Promise<PublishResponse> {
    try {
      await this._protoo.notify("peerMsgText", {
        peerId,
        msg: message,
        //TODO: options
      });
      return { timeToken: Date.now(), channelName: peerId };
    } catch (error) {
      logger.debug(`publishToPeer failed:${error}`);
      throw {
        error: true,
        operation: "logout",
        errorCode: 0,
        reason: "publish failed",
      };
    }
  }

  //可以直接调用 publish 方法向订阅该频道的所有在线用户发送消息。即使没有订阅频道，也能在频道中发送消息
  async publish(
    channelName: string,
    message: string,
    options?: { customType?: string }
  ): Promise<PublishResponse> {
    try {
      await this._protoo.notify("channelMsgText", {
        channelId: channelName,
        msg: message,
        //TODO: options
      });
      return { timeToken: Date.now(), channelName: channelName };
    } catch (error) {
      logger.debug(`subscribe failed:${error}`);
      throw {
        error: true,
        operation: "logout",
        errorCode: 0,
        reason: "publish failed",
      };
    }
  }
}
